import React from 'react';
import { connect } from 'react-redux';
import Loader from 'components/Loader/Loader';
import { AppState } from '../reducers/reducers';
import { selectedSpotInfo } from '../selectors';
import AGButton from 'components/Button/Button';
import ExternalLinkIcon from 'components/Icons/ExternalLinkIcon';
import env from 'env';

type SlotsModuleContainerProps = ReturnType<typeof mapStateToProps>;
const SlotsModuleContainer = (props: SlotsModuleContainerProps) => {
    const { spot, superuser } = props;

    if (!spot) {
        return <Loader />;
    }

    const invoice_link = `${env.API_DOMAIN}${env.DJANGO_ADMIN_PATH}spots/slot/custom_invoice_creation/${spot.pk}`;

    return (
        <div>
            {superuser && (
                <>
                    <h3>Create a custom invoice for {spot.name}.</h3>
                    <AGButton
                        type="button"
                        size="md"
                        onClick={() => {
                            window.open(invoice_link, '_blank');
                        }}
                        style={{ width: '250px' }}
                        className="unfilled-icon"
                    >
                        Create an Invoice <ExternalLinkIcon />
                    </AGButton>
                </>
            )}
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        spot: selectedSpotInfo(state),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        superuser: state.auth.profile!.superuser,
    };
}

export default connect(mapStateToProps)(SlotsModuleContainer);
